var zh = require('./zh.js')
var layoutProfiles = require('./layoutProfiles.js')
var inlineLinkTargets = require('./inlineLinkTargets.js')
var ctaLabels = require('./ctaLabels.js')
var en = require('./en.js')
var ja = require('./ja.js')
var ko = require('./ko.js')
var fr = require('./fr.js')
var es = require('./es.js')
var it = require('./it.js')
var de = require('./de.js')
var pt = require('./pt.js')
var pl = require('./pl.js')
var ar = require('./ar.js')

var LOCALE_MODULES = {
  zh: zh,
  en: en,
  ja: ja,
  ko: ko,
  fr: fr,
  es: es,
  it: it,
  de: de,
  pt: pt,
  pl: pl,
  ar: ar
}

var DEFAULT_LOCALE = 'en'
var SUPPORTED_LOCALES = Object.keys(LOCALE_MODULES)

function normalizeHubLocale(locale) {
  var lang = String(locale || '').toLowerCase()
  if (LOCALE_MODULES[lang]) return lang
  return DEFAULT_LOCALE
}

function getLocaleModule(locale) {
  return LOCALE_MODULES[normalizeHubLocale(locale)]
}

function getHubText(locale, key) {
  var text = getLocaleModule(locale).HUB_TEXT || {}
  return text[key] || zh.HUB_TEXT[key] || key
}

function getHubTextList(locale, key) {
  var value = getHubText(locale, key)
  return Array.isArray(value) ? value : []
}

function getHubCategories(locale) {
  return getLocaleModule(locale).getHubCategories()
}

function getHubArticles(locale, category) {
  return getLocaleModule(locale).getHubArticles(category)
}

function getHubArticle(locale, slug) {
  return getLocaleModule(locale).getHubArticle(slug)
}

function getHubCategory(locale, key) {
  return getLocaleModule(locale).getHubCategory(key)
}

function getRelatedArticles(locale, article) {
  return getLocaleModule(locale).getRelatedArticles(article)
}

function getHubFeaturedArticles(locale, category) {
  return getLocaleModule(locale).getHubFeaturedArticles(category)
}

function searchHubArticles(locale, query, category) {
  return getLocaleModule(locale).searchHubArticles(query, category)
}

function getHubSearchSuggestions(locale, limit, category) {
  return getLocaleModule(locale).getHubSearchSuggestions(limit, category)
}

function getCommonModelLinks(locale) {
  return getLocaleModule(locale).COMMON_MODEL_LINKS || zh.COMMON_MODEL_LINKS
}

function getCommonToolLinks(locale) {
  return getLocaleModule(locale).COMMON_TOOL_LINKS || zh.COMMON_TOOL_LINKS
}

function getHubFeatureLinks(locale) {
  return getLocaleModule(locale).HUB_FEATURE_LINKS || zh.HUB_FEATURE_LINKS
}

function buildArticleNavTree(locale, article) {
  return getLocaleModule(locale).buildArticleNavTree(article)
}

function countHubSectionBlocks(section, blockType) {
  return zh.countHubSectionBlocks(section, blockType)
}

function shouldCollapseHubSection(section, sectionId, blockType) {
  return zh.shouldCollapseHubSection(section, sectionId, blockType)
}

function hiddenHubSectionBlockCount(section, blockType) {
  return zh.hiddenHubSectionBlockCount(section, blockType)
}

function buildHubCollapsibleEntries(section, blockType, mode) {
  return zh.buildHubCollapsibleEntries(section, blockType, mode)
}

function getInlineLinkTargets(locale) {
  return inlineLinkTargets.getInlineLinkTargets(locale, getHubTextList(locale, 'docSearchAliasLinks'))
}

function getFreeTrialLabel(locale, label) {
  return ctaLabels.formatFreeTrialLabel(
    normalizeHubLocale(locale),
    label,
    getHubText(locale, 'tryForFreeTemplate')
  )
}

module.exports = {
  DEFAULT_LOCALE: DEFAULT_LOCALE,
  SUPPORTED_LOCALES: SUPPORTED_LOCALES,
  LOCALE_MODULES: LOCALE_MODULES,
  HUB_CATEGORIES: zh.HUB_CATEGORIES,
  HUB_ARTICLES: zh.HUB_ARTICLES,
  HUB_TEXT: zh.HUB_TEXT,
  HUB_COLLAPSIBLE_VISIBLE_COUNT: zh.HUB_COLLAPSIBLE_VISIBLE_COUNT,
  COMMON_MODEL_LINKS: zh.COMMON_MODEL_LINKS,
  COMMON_TOOL_LINKS: zh.COMMON_TOOL_LINKS,
  HUB_FEATURE_LINKS: zh.HUB_FEATURE_LINKS,
  normalizeHubLocale: normalizeHubLocale,
  getHubText: getHubText,
  getHubTextList: getHubTextList,
  getHubCategories: getHubCategories,
  getHubArticles: getHubArticles,
  getHubArticle: getHubArticle,
  getHubCategory: getHubCategory,
  getRelatedArticles: getRelatedArticles,
  getHubFeaturedArticles: getHubFeaturedArticles,
  searchHubArticles: searchHubArticles,
  getHubSearchSuggestions: getHubSearchSuggestions,
  getCommonModelLinks: getCommonModelLinks,
  getCommonToolLinks: getCommonToolLinks,
  getHubFeatureLinks: getHubFeatureLinks,
  buildArticleNavTree: buildArticleNavTree,
  countHubSectionBlocks: countHubSectionBlocks,
  shouldCollapseHubSection: shouldCollapseHubSection,
  hiddenHubSectionBlockCount: hiddenHubSectionBlockCount,
  buildHubCollapsibleEntries: buildHubCollapsibleEntries,
  getFreeTrialLabel: getFreeTrialLabel,
  get demoImages() {
    return require('./demoImages.js')
  },
  layoutProfiles: layoutProfiles,
  getInlineLinkTargets: getInlineLinkTargets
}
